import { FC } from 'react'
import { District } from 'graphql/types'
import Label from 'components/Label'
import Typography from 'components/Typography'
import styles from './NeighborhoodInfo.module.scss'

export type TProps = Pick<District, 'name' | 'description'>

const NeighborhoodInfo: FC<TProps> = ({ name, description }) => {
  if (!name || !description) return null

  return (
    <div>
      <Label text="Guia de bairros" variant="grey" />
      <div className={styles.ecNeighborhoodDescriptionInfo}>
        <Typography variant="Title" bold>
          Conheça {name}
        </Typography>
        <Typography className={styles.ecNeighborhoodDescriptionText}>
          {description}
        </Typography>
      </div>
    </div>
  )
}

export default NeighborhoodInfo
